import React from "react";
import { Col } from "react-bootstrap";

import ChatHeader from "./components/ChatHeader";
import ChatInput from "./components/ChatInput";
import ChatMessages from "./components/ChatMessages";

const ChatContainer = () => {
  return (
    <div id="chat-container" className="bg-gray">
      <ChatHeader />

      <Col className="chat-col" xs={12}>
        <ChatMessages />
        <ChatInput />
      </Col>
    </div>
  );
};

export default ChatContainer;